import React from "react";

import { Action, Label, ButtonContainer } from "shared/components";
import { Spacer } from "shared/layout";
import { IFormFieldStyle, IUnitType } from "shared/types";
import { copy } from "shared/assets";

const { unitType } = copy;

interface UnitConverterProps {
  currentUnitType?: IUnitType;
  setUnitType: (type: IUnitType) => void;
  style?: IFormFieldStyle;
}
export const UnitConverter: React.FC<UnitConverterProps> = ({
  currentUnitType = IUnitType.metric,
  setUnitType,
  ...rest
}) => {
  return (
    <Spacer size="xxs" {...rest}>
      <Label>Unit type</Label>
      <ButtonContainer>
        <Action
          label={unitType.metric.label}
          subLabel={unitType.metric.suffix}
          isActive={currentUnitType === IUnitType.metric}
          handleClick={() => setUnitType(IUnitType.metric)}
          size="m"
        />
        <Action
          label={unitType.imperial.label}
          subLabel={unitType.imperial.suffix}
          isActive={currentUnitType === IUnitType.imperial}
          handleClick={() => setUnitType(IUnitType.imperial)}
          size="m"
        />
      </ButtonContainer>
    </Spacer>
  );
};
